// Custom cursor
const cur = document.getElementById('cur');
const ring = document.getElementById('curRing');
if (cur && ring) {
  let mx = 0, my = 0, rx = 0, ry = 0;
  document.addEventListener('mousemove', e => { mx = e.clientX; my = e.clientY; });
  (function tick() {
    cur.style.left = mx + 'px'; cur.style.top = my + 'px';
    rx += (mx - rx) * .12; ry += (my - ry) * .12;
    ring.style.left = rx + 'px'; ring.style.top = ry + 'px';
    requestAnimationFrame(tick);
  })();
}

// Sticky nav
const nav = document.getElementById('mainNav');
if (nav) window.addEventListener('scroll', () => nav.classList.toggle('scrolled', window.scrollY > 50));

// Scroll reveal
const obs = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in'); });
}, { threshold: 0.1 });
document.querySelectorAll('.reveal').forEach(el => obs.observe(el));

// AJAX add to cart
function addToCart(variantId, btn) {
  if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(r => r.json())
  .then(() => {
    if (btn) { btn.textContent = 'Added ✓'; setTimeout(() => { btn.textContent = '+ Add'; btn.disabled = false; }, 1800); }
    return fetch('/cart.js');
  })
  .then(r => r.json())
  .then(cart => {
    const bagBtn = document.querySelector('.nav-cart');
    if (bagBtn) bagBtn.textContent = 'Bag (' + cart.item_count + ')';
  })
  .catch(() => { if (btn) { btn.textContent = '+ Add'; btn.disabled = false; } });
}
